import React, { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: bold;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
`;

const SelectWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;

  select {
    font-size: 16px;
    padding: 4px 8px;
  }
`;

const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  font-size: 18px;
  text-align: center;
`;

const Day = styled.div<{ isToday?: boolean }>`
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border-radius: 100px;
  background-color: ${({ isToday }) => (isToday ? "#0C8CE9" : "transparent")};
  color: ${({ isToday }) => (isToday ? "white" : "black")};
  cursor: pointer;
  &:hover {
    background-color: #f3f4f6;
  }
`;

const weekdays = ["일", "월", "화", "수", "목", "금", "토"];

interface Props {
  initialDate?: string; // yyyy-mm-dd
  onClose: () => void;
  onSelect: (date: string) => void;
}

export default function DateModalComponent({
  initialDate,
  onClose,
  onSelect,
}: Props) {
  const now = new Date();
  const parsedDate = initialDate ? new Date(initialDate) : now;

  const [year, setYear] = useState(parsedDate.getFullYear());
  const [month, setMonth] = useState(parsedDate.getMonth());
  const [selectedDay, setSelectedDay] = useState(parsedDate.getDate());

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfWeek = new Date(year, month, 1).getDay();

  const handleSelect = (day: number) => {
    const formatted = `${year}-${String(month + 1).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;
    setSelectedDay(day);
    onSelect(formatted);
    onClose();
  };

  return (
    <Container>
      <Header>
        [작업예정일] 날짜 입력
        <CloseButton onClick={onClose}>×</CloseButton>
      </Header>

      <SelectWrapper>
        <select value={year} onChange={(e) => setYear(+e.target.value)}>
          {Array.from({ length: 10 }, (_, i) => now.getFullYear() - 5 + i).map(
            (y) => (
              <option key={y} value={y}>
                {y}
              </option>
            )
          )}
        </select>
        <select value={month} onChange={(e) => setMonth(+e.target.value)}>
          {Array.from({ length: 12 }, (_, i) => (
            <option key={i} value={i}>
              {i + 1 < 10 ? `0${i + 1}` : i + 1}
            </option>
          ))}
        </select>
      </SelectWrapper>

      <CalendarGrid>
        {weekdays.map((d) => (
          <div key={d} style={{ fontWeight: "bold" }}>
            {d}
          </div>
        ))}
        {Array.from({ length: firstDayOfWeek }).map((_, i) => (
          <div key={`empty-${i}`} />
        ))}
        {Array.from({ length: daysInMonth }).map((_, i) => (
          <Day
            key={i + 1}
            isToday={selectedDay === i + 1}
            onClick={() => handleSelect(i + 1)}
          >
            {i + 1}
          </Day>
        ))}
      </CalendarGrid>
    </Container>
  );
}
